import React, { useEffect, useRef } from 'react'
import ShippingInfo from './shippinginfo'
import partsService from "../../../../services/partsservice";
import helperfunctions from '../../../../utils/helperfunctions';
import { containerIprops } from './shippinginfointerface';
import { useCartContext } from '../../../ShoppingCart/shoppingcart';
import { ICartContextType } from '../../../ShoppingCart/ShoppingCartPromo/shoppingcartpromointerface';

const ShippingInfoContainer = (props: containerIprops) => {
    const { setCountryList, setStateList, countryList, stateList, isNextClick } = props;
    const { stepperDetails }: ICartContextType = useCartContext();
    const initialDataList = { loading: false, data: [] };
    const initialLoadingDataList = { loading: true, data: [] };
    const infoErrorObj = {
        savedAddress: false, companyName: false, firstName: false, lastName: false,
        address1: false, address2: false, city: false, countryName: false, stateName: false, postalCode: false,
        name: false, phone: false, phoneCountryCode: false, attention: false
    }
    const [isPhoneUpdated, setIsPhoneUpdated] = React.useState(false);

    useEffect(() => {
        if (stepperDetails?.shipment?.countryCode) {
            getStateList(stepperDetails?.shipment?.countryCode)
        }
        getCountryList();
    }, []);

    const refs:any = {...props?.baseRef,
        phoneCountryCode: useRef<HTMLDivElement>(null),
        phone: useRef<HTMLDivElement>(null),
        attention: useRef<HTMLDivElement>(null)};
    
    const scrollToErrorField = () => {
        const errorFields = [
            'savedAddress',
            'firstName',
            'lastName',
            'address1',
            'city',
            'countryName',
            'stateName',
            'postalCode',
            'phoneCountryCode',
            'phone',
            'attention'
        ];
    
        const firstErrorField = errorFields.find((field) => stepperDetails?.shipment?.error?.[field]);
    
        if (firstErrorField && refs[firstErrorField].current) {
            refs[firstErrorField].current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    useEffect(() => {
        const errorObj = stepperDetails?.shipment?.error;
        if (errorObj && Object.keys(errorObj) && isNextClick) {
            scrollToErrorField();
        }
    }, [ isNextClick ]);

    const getCountryList = async () => {
        try {
            setCountryList(initialLoadingDataList);
            const response = await partsService.getCountryList();
            if (response?.isSuccess) {
                setCountryList({ loading: false, data: response?.data ?? [] });
            } else {
                setCountryList(initialDataList);
                helperfunctions.showErrorMessage(`${response?.msg}`);
            }
        } catch (error) {
            setCountryList(initialDataList);
            helperfunctions.showErrorMessage(`${error}`);
        }
    }

    const getStateList = async (countryCode: any) => {
        if (countryCode) {
            try {
                setStateList(initialLoadingDataList);
                const response = await partsService.getStateList(countryCode);
                if (response?.isSuccess) {
                    setStateList({ loading: false, data: response?.data ?? [] });
                } else {
                    setStateList(initialDataList);
                    helperfunctions.showErrorMessage(`${response?.msg}`);
                }
            } catch (error) {
                setStateList(initialDataList);
                helperfunctions.showErrorMessage(`${error}`);
            }
        } else {
            setStateList(initialDataList);
        }
    }

    const getPostalCode = (value: any) => {
        let val = stepperDetails?.shipment?.postalCode ?? '';
        const regex = /[^A-Za-z0-9]/;
        if (value && value?.trim()?.length) {
            if (!regex.test(value) && value?.length <= 9) {
                val = value;
            }
        } else {
            val = '';
        }

        return val;
    }


    const getFormattedPhone = (value: any, stepperDetails: any) => {
        const inputValue = getPhoneCodeValue(value);
        const phone = stepperDetails?.shipment?.phone ?? '';
        const formattedPhone = inputValue === '+1' ? helperfunctions.formatPhoneNumber(phone) : phone?.replace(/\D/g, '');
        const phoneValue = formattedPhone ? getPhoneData(formattedPhone, inputValue) : ''
        return { inputValue, phoneValue };
    };

    const onShippingInfoChange = (value: any, name: string) => {
        setIsPhoneUpdated(false);
        const errorObj = { ...stepperDetails?.shipment?.error };
        errorObj[name] = false;
        const err = { ...errorObj, isReqForShippingMethod: false };
        if (name?.toLowerCase() === 'savedaddress') {
            updateSavedAddress(value, name, err);
        }
        else {
            let shipmentObj = { ...stepperDetails?.shipment, error: err }
            if (name === 'postalCode') {
                let val = getPostalCode(value);
                shipmentObj = { ...stepperDetails?.shipment, [name]: val, error: err }
            }
            else if (name === 'countryName') {
                const countryCode: any = countryList?.data.find((country: any) => country?.name === value);
                shipmentObj = { ...shipmentObj, countryCode: getValueWithNullCheck(countryCode?.id), countryName: getValueWithNullCheck(value), stateName: '', stateCode: '' }
                countryChange(value, countryCode?.id, shipmentObj);
            }
            else if (name === 'stateName') {
                const stateCode: any = stateList?.data.find((state: any) => state?.name === value);
                shipmentObj = { ...shipmentObj, stateCode: getValueWithNullCheck(stateCode?.id), stateName: getValueWithNullCheck(value) }
                if(value) {
                    props.getShippingCarriers(stepperDetails?.shipment?.shippingMethodId, shipmentObj);
                }
            }
            else if (name === 'phone') {
                const phoneNum = getPhoneData(value, stepperDetails?.shipment?.phoneCountryCode);
                const err = { ...errorObj, isInvalidPhone: false, contactPhone: false };
                shipmentObj = { ...stepperDetails?.shipment, [name]: phoneNum, error: err }
            }
            else if (name === "phoneCountryCode") {
                const {inputValue, phoneValue} = getFormattedPhone(value, stepperDetails);
                shipmentObj = { ...stepperDetails?.shipment, [name]: inputValue, phone: phoneValue, error: err };
                setIsPhoneUpdated(true);
            }
            else {
                shipmentObj = { ...stepperDetails?.shipment, [name]: value, error: err };
            }
            props?.updateShipmentDetails(shipmentObj);
        }
    }

    const getPhoneData = (value : any, phoneCode: any) =>
    {
       return phoneCode == "+1" ? value : value?.replace(/\D/g, '');
    }

    const getValueWithNullCheck = (val: any) => {
        return val ?? "";
    }

    const getPhoneCodeValue = (value: any) => {
        const valueSplit = value?.split("|");
        return valueSplit?.length > 0 ? valueSplit[0] : "";
    }

    const countryChange = (value: any, id:any, shipmentObj: any) => {
        if (value) {
            props.getShippingCarriers(stepperDetails?.shipment?.shippingMethodId, shipmentObj);
            getStateList(id);
            if (stepperDetails?.shipment?.postalCode) {
                props?.getWeatherWarning(stepperDetails?.shipment?.postalCode, id);
            }
        } else {
            setStateList(initialDataList);
        }
    }

    const updateSavedAddress = (value: any, name: any, err: any) => {
        const selectedObj: any = props?.savedAddressList?.data?.find((item: any) => item?.addressId === value) ?? {};
        if (value == 0) {
            props?.updateShipmentDetails({
                ...stepperDetails?.shipment, companyName: '', firstName: '', lastName: '',
                address1: '', address2: '', city: '', countryCode: '', stateCode: '', countryName: '', stateName: '', postalCode: '', weatherWarning: '',
                attention: '', phoneCountryCode: '', phone: '',
                [name]: value, addressId: 0, error: { ...err, ...infoErrorObj }
            });
            setStateList(initialDataList)
        }
        else {
            getStateList(selectedObj?.countryCode)
            props?.updateShipmentDetails({ ...stepperDetails?.shipment, ...selectedObj, [name]: value, error: { ...err, ...infoErrorObj } });
            if (selectedObj?.postalCode) {
                props?.getWeatherWarning(selectedObj?.postalCode, selectedObj?.countryCode);
            }
        }
    }

    const onBlurZip = (value: any) => {
        props?.getWeatherWarning(value, stepperDetails?.shipment?.countryCode);
        if(value) {
            props.getShippingCarriers(stepperDetails?.shipment?.shippingMethodId);
        }
    }

    const handleIsPhoneUpdated = (isUpdated: boolean) => {
        setIsPhoneUpdated(isUpdated);
    }

    const onBlurCity = (value: any) => {    
        if(value) {
            props.getShippingCarriers(stepperDetails?.shipment?.shippingMethodId);
        }
    }

    return (
        <ShippingInfo
            onShippingInfoChange={onShippingInfoChange}
            shipmentDetails={stepperDetails?.shipment}
            savedAddressList={props?.savedAddressList}
            stateList={stateList}
            countryList={countryList}
            weatherWarning={props?.weatherWarning}
            savedAddressOptions={props?.savedAddressOptions}
            onBlurZip={onBlurZip}
            getDivRef={props?.getDivRef}
            phoneCodeOption={props?.phoneCodeOption}
            refs={refs}
            isPhoneUpdated={isPhoneUpdated}
            handleIsPhoneUpdated={handleIsPhoneUpdated}
            onBlurCity={onBlurCity}
        />
    )
}

export default ShippingInfoContainer